/*
 * UR MARK — sticky filter/sort bar "stuck" shadow
 *
 * Purely cosmetic: adds .is-stuck to [data-sticky-watch] once it has actually
 * scrolled up against the top of the viewport, so the sticky bar picks up a
 * small shadow that reads as "floating" rather than sitting flush the whole
 * time. The stickiness itself is pure CSS (position: sticky); this only
 * toggles the shadow class.
 */
(function () {
  'use strict';

  function watch(el) {
    var sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:absolute;top:0;height:1px;width:1px;pointer-events:none;';
    el.parentNode.insertBefore(sentinel, el);

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          el.classList.toggle('is-stuck', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    observer.observe(sentinel);
  }

  function init() {
    document.querySelectorAll('[data-sticky-watch]').forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
